import { render, staticRenderFns } from "./ComplianceResourceList.vue?vue&type=template&id=a2d93c18&scoped=true"
import script from "./ComplianceResourceList.vue?vue&type=script&lang=js"
export * from "./ComplianceResourceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2d93c18",
  null
  
)

export default component.exports